export const REGIMENES = {
  SA: 'SA',
  AD: 'AD',
  AD_MP: 'AD_MP',
  MP: 'MP',
  PC: 'PC',
  TI: 'TI',
};

export const REGIMENES_ARRAY = ['SA', 'AD', 'AD_MP', 'MP', 'PC', 'TI', 'SD'];

export const REGIMENES_SET = new Set(REGIMENES_ARRAY);
